import axios from 'axios';

const API_BASE = '/api/forms';

// 📑 결재양식 목록 조회
export const getForms = async (token) => {
  const res = await axios.get(API_BASE, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 📑 결재양식 단건 조회
export const getFormByCode = async (formCode, token) => {
  const res = await axios.get(`${API_BASE}/${formCode}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const createForm = async (data, token) => {
  const payload = {
    ...data,
    parent_code: data.parent_code && data.parent_code.trim() !== '' 
      ? data.parent_code 
      : 'root',   // ✅ parent_code가 없으면 root로 저장
  };

  const res = await axios.post('/api/forms', payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};


// 📑 결재양식 수정
export const updateForm = async (formCode, data, token) => {
  const res = await axios.put(`${API_BASE}/${formCode}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 📑 결재양식 삭제
export const deleteForm = async (formCode, token) => {
  const res = await axios.delete(`${API_BASE}/${formCode}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 📑 권한 목록 조회
export const getFormAuths = async (formCode, token) => {
  const res = await axios.get(`${API_BASE}/${formCode}/auth`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 📑 권한 추가
export const addFormAuth = async (formCode, data, token) => {
  const res = await axios.post(`${API_BASE}/${formCode}/auth`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

// 📑 권한 삭제
export const deleteFormAuth = async (formCode, targetType, targetId, token) => {
  const res = await axios.delete(`${API_BASE}/${formCode}/auth/${targetType}/${targetId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};


// 📑 트리 구조 조회
export const getFormsTree = async (token) => {
  const res = await axios.get(`${API_BASE}?view=tree`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};